import { render, staticRenderFns } from "./ReceiveRecordDetail.vue?vue&type=template&id=69327755&scoped=true"
import script from "./ReceiveRecordDetail.vue?vue&type=script&lang=js"
export * from "./ReceiveRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./ReceiveRecordDetail.vue?vue&type=style&index=0&id=69327755&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69327755",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69327755')) {
      api.createRecord('69327755', component.options)
    } else {
      api.reload('69327755', component.options)
    }
    module.hot.accept("./ReceiveRecordDetail.vue?vue&type=template&id=69327755&scoped=true", function () {
      api.rerender('69327755', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/record/modules/ReceiveRecordDetail.vue"
export default component.exports